module.exports = __webpack_public_path__ + "static/media/bg2.ee636736.png";